export const CLASS_LEADERBOARDS_KEY = "class-leaderboards";
